import React, { useEffect, useState } from 'react'
import Spinner from '../components/Spinner/Spinner';

const CookiePolicy = () => {
    const [Spinner1, setSpinner1] = useState(false)

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://app.termly.io/embed-policy.min.js";
        script.async = true;
        document.body.appendChild(script);
      }, []); 

  return (
    <div
    className="page-container"
      name="termly-embed"
      data-id="3ffeec89-2b93-4b98-af14-6ea69e0867e7"
      data-type="iframe"
      style={{
        marginBottom:"20px"
      }}
    ></div>
  )
}

export default CookiePolicy